export type TrendDirection = "up" | "down" | "flat";

export type HotItem = {
  id: string;
  rank: number;
  title: string;
  category: string;
  heat: number;
  trend: TrendDirection;
  note: string;
};

export const hotRanking: HotItem[] = [
  {
    id: "hot-01",
    rank: 1,
    title: "新剧路透提前流出，剧组连夜调整拍摄顺序",
    category: "影视",
    heat: 986,
    trend: "up",
    note: "话题仍在持续发酵",
  },
  {
    id: "hot-02",
    rank: 2,
    title: "综艺录制现场起争执，现场收音片段被传开",
    category: "综艺",
    heat: 921,
    trend: "up",
    note: "节目组暂未公开回应",
  },
  {
    id: "hot-03",
    rank: 3,
    title: "女团成员深夜聚会画面曝光，同行者身份成谜",
    category: "偶像",
    heat: 877,
    trend: "flat",
    note: "讨论集中在人物关系",
  },
  {
    id: "hot-04",
    rank: 4,
    title: "音乐节压轴阵容临时改期，主办方给出新说明",
    category: "音乐",
    heat: 834,
    trend: "down",
    note: "退票方案同步更新",
  },
  {
    id: "hot-05",
    rank: 5,
    title: "新片选角名单外泄，多名配角经历被逐条比对",
    category: "影视",
    heat: 788,
    trend: "up",
    note: "材料库新增对照表",
  },
  {
    id: "hot-06",
    rank: 6,
    title: "品牌代言临时更换，台前幕后时间线被重新梳理",
    category: "商业",
    heat: 742,
    trend: "flat",
    note: "关注点转向合约细节",
  },
  {
    id: "hot-07",
    rank: 7,
    title: "直播专场数据争议升级，第三方统计口径被质疑",
    category: "直播",
    heat: 703,
    trend: "down",
    note: "已出现多份对比截图",
  },
  {
    id: "hot-08",
    rank: 8,
    title: "工作室回应旧闻翻出，早年采访片段被重新解读",
    category: "影视",
    heat: 668,
    trend: "up",
    note: "回应原文已归档",
  },
];

export type FeedItem = {
  id: string;
  time: string;
  day: string;
  title: string;
  summary: string;
  source: string;
  tag: string;
};

export const newsFeed: FeedItem[] = [
  {
    id: "feed-01",
    time: "10:42",
    day: "今天",
    title: "争执事件补充材料：现场录音文字稿已整理上线",
    summary:
      "快讯流刚刚更新了第二版材料，按时间顺序补齐了入场、彩排与中断三个节点，方便直接对照原始说法。",
    source: "爆料直达",
    tag: "跟进中",
  },
  {
    id: "feed-02",
    time: "09:15",
    day: "今天",
    title: "路透流出的拍摄计划表出现两处手写改动",
    summary:
      "对照原始计划表后，发现两处场次被临时前移，与传闻中的调整时间基本吻合，具体原因仍在核实。",
    source: "材料库",
    tag: "新材料",
  },
  {
    id: "feed-03",
    time: "22:08",
    day: "昨天",
    title: "深夜聚会画面新增一段门口视角，拍摄时间可确认",
    summary:
      "新增画面带有明显环境参照，时间点与前一版相差不到十分钟，已并入同一条事件时间线。",
    source: "瓜点聚合",
    tag: "已核实",
  },
  {
    id: "feed-04",
    time: "19:36",
    day: "昨天",
    title: "音乐节改期说明全文公开，退票与改签规则分列",
    summary:
      "主办方补充了改期原因与后续安排，我们把说明全文与之前的沟通记录放在同一个入口，便于横向比对。",
    source: "入口导航",
    tag: "官方说明",
  },
  {
    id: "feed-05",
    time: "15:20",
    day: "昨天",
    title: "选角名单外泄版本出现第三个来源，字段差异已标注",
    summary:
      "三个版本在角色名与备注栏上存在差异，已用对照表标出不同点，避免把留言当成定稿。",
    source: "深挖材料",
    tag: "多源对照",
  },
  {
    id: "feed-06",
    time: "11:04",
    day: "前天",
    title: "直播数据争议出现第三方口径，对比图更新至第二版",
    summary:
      "新增一份统计口径说明，把在线人数与互动量分列，争议点从总量转向统计方式。",
    source: "热度榜",
    tag: "数据核对",
  },
  {
    id: "feed-07",
    time: "08:50",
    day: "前天",
    title: "旧采访片段被重新解读，工作室回应已完整归档",
    summary:
      "把回应原文、采访原片与二次解读放在同一条时间线上，方便看清信息是在哪一步发生偏移的。",
    source: "材料库",
    tag: "回应归档",
  },
];

export const feedTicker: string[] = [
  "新材料：现场录音文字稿已整理",
  "热度榜更新：新剧路透升至第 1 位",
  "多源对照：第三版选角名单已标注差异",
  "回应归档：工作室原文完整保存",
  "跟进中：音乐节改期退票细则已公开",
  "快讯流：24 小时新增 18 条线索",
];

export type MaterialItem = {
  id: string;
  tag: string;
  title: string;
  excerpt: string;
  readCount: string;
  image: string;
};

export const materials: MaterialItem[] = [
  {
    id: "material-01",
    tag: "材料库",
    title: "事件档案：从第一条线索到最新进展的全记录",
    excerpt:
      "把散落在各处的截图、文字稿与回应按时间顺序归档，每条线索都标注来源与收录时间，方便随时回溯。",
    readCount: "1.8 万",
    image:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20vintage%20case%20files%20and%20folded%20newspapers%20on%20a%20warm%20beige%20paper%20background%2C%20a%20crimson%20wax%20seal%20in%20the%20corner%2C%20dramatic%20side%20lighting%2C%20editorial%20investigation%20mood%2C%20high%20detail%2C%20clean%20simple%20backdrop%2C%20no%20people&width=800&height=600&seq=heiliao-material-01&orientation=landscape",
  },
  {
    id: "material-02",
    tag: "深挖",
    title: "对照表：三个版本的关键字段差异一次看清",
    excerpt:
      "将多份外泄版本的字段并排摆放，标出角色名、备注栏与日期的不同点，避免把不同来源混成同一份定稿。",
    readCount: "1.2 万",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20magnifying%20glass%20resting%20over%20blurred%20printed%20documents%20on%20a%20warm%20cream%20desk%2C%20soft%20natural%20window%20light%2C%20editorial%20investigation%20atmosphere%2C%20clean%20minimal%20background%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=heiliao-material-02&orientation=landscape",
  },
  {
    id: "material-03",
    tag: "时间线",
    title: "时间线梳理：每一次说法变化都有对应节点",
    excerpt:
      "从最早的说法到最近的回应，按小时级节点排开，任何一次措辞变化都能立刻定位到具体时间。",
    readCount: "9600",
    image:
      "https://readdy.ai/api/search-image?query=Stacked%20paper%20evidence%20folders%20tied%20with%20red%20ribbon%20on%20a%20warm%20sand%20colored%20surface%2C%20overhead%20flat%20lay%20composition%2C%20soft%20diffused%20shadow%2C%20minimal%20editorial%20product%20photography%2C%20high%20detail%2C%20clean%20simple%20backdrop%2C%20no%20people&width=800&height=600&seq=heiliao-material-03&orientation=landscape",
  },
  {
    id: "material-04",
    tag: "瓜点",
    title: "后续跟进：热度之外，被忽略的两个细节",
    excerpt:
      "在热度榜之外，还有两条关注度不高的材料同样值得看，我们把它单独拎出来，避免被刷屏内容淹没。",
    readCount: "7300",
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20typewriter%20surrounded%20by%20scattered%20handwritten%20notes%20on%20a%20warm%20taupe%20background%2C%20moody%20directional%20side%20lighting%2C%20editorial%20storytelling%20photography%2C%20clean%20simple%20backdrop%2C%20high%20detail%2C%20no%20people&width=800&height=600&seq=heiliao-material-04&orientation=landscape",
  },
];

export const entryTags: string[] = [
  "黑料bu爆料",
  "黑料bu入口",
  "黑料bu新料入口",
  "黑料bu爆料直达",
  "热榜速览",
  "快讯流",
  "材料库",
  "多源对照",
  "回应归档",
  "事件时间线",
  "路透线索",
  "跟进后续",
];

export type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

export const faqs: FaqItem[] = [
  {
    id: "faq-01",
    question: "黑料bu 的爆料入口更新频率是怎样的？",
    answer:
      "快讯流按天更新，热度榜每天调整一次排序，材料库在有新线索时会随时补充，一般都能在节点出现后的短时间内看到整理结果。",
  },
  {
    id: "faq-02",
    question: "热度榜的排序是怎么来的？",
    answer:
      "主要参考线索的新鲜程度、被多家来源提及的次数以及跟进讨论的活跃度，热度值只是相对参考，不代表对事件的最终判断。",
  },
  {
    id: "faq-03",
    question: "想第一时间跟进爆料后续，看哪一块最合适？",
    answer:
      "建议先看快讯流掌握最新动态，再到材料库查看对应的原始材料与对照表，两部分配合一起看，能更快拼出完整脉络。",
  },
  {
    id: "faq-04",
    question: "页面上的内容可以直接转载吗？",
    answer:
      "页面内容仅作线索聚合与浏览参考，涉及原始材料的部分请以来源说明为准，引用前请自行核实并注明出处。",
  },
];